import React from 'react';

const ClientTypes = () => {
  const clientTypes = [
    {
      icon: "ri-store-2-line",
      title: "Small & Mid-Size Businesses",
      description: "Growing companies ready to scale operations with technology but need guidance on where to start."
    },
    {
      icon: "ri-building-line",
      title: "Traditional Businesses Adopting Tech",
      description: "Established businesses transitioning from manual processes to digital systems and automation."
    },
    {
      icon: "ri-file-list-3-line",
      title: "Companies Stuck in Manual Processes",
      description: "Businesses relying on Excel, WhatsApp, and manual workflows that need integrated systems."
    }
  ];

  return (
    <section id="client-types" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">We Work With</h2>
          <div className="w-20 h-1 bg-primary mx-auto mb-8"></div>
          <p className="max-w-3xl mx-auto text-lg text-gray-700">
            We partner with businesses ready to eliminate bottlenecks and grow through smart technology.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {clientTypes.map((client, index) => (
            <div key={index} className="bg-gray-50 p-8 rounded-lg hover:shadow-lg transition-all border-t-4 border-primary">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className={`${client.icon} ri-2x text-primary`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3 text-center">{client.title}</h3>
              <p className="text-gray-700 text-center">{client.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientTypes;
